<template>
    <div id="editorialRole">
        <el-container>
            <el-header>
                <top-Nav></top-Nav>
            </el-header>
            <el-main>
                <el-row>
                    <div>
                        <div class="mainHead">
                            <div class="route">
                                <span class="crumbs"></span><span @click="linkIndex" class="router_link">角色管理</span><span class="arrow">></span><span>{{msg}}</span><span></span>
                            </div>
                            <div>
                                <el-button type="primary" @click="getAddRoles()" v-if="!isLook && isAuth('common:interface')">保存</el-button>
                                <el-button type="primary" @click="returnBtn()">返回</el-button>
                            </div>
                        </div>
                    </div>
                    <div class="mains clearfix">
                        <div class="mains_left">
                            <el-form :model="ruleForm" ref="ruleForm" label-width="122px" class="demo-ruleForm" :class="{is_look:isLook}">
                                <el-form-item label="角色名称:" prop="name" :required="true" :show-message="false">
                                    <el-input v-model="ruleForm.name" placeholder="长度不超过8个字符" :maxlength="8" :disabled="isManger"></el-input>
                                </el-form-item>
                                <el-form-item label="启用状态:" prop="enabled" :required="true" :show-message="false">
                                    <el-radio v-model="ruleForm.enabled" :label="false" :disabled="isLook">启用</el-radio>
                                    <el-radio v-model="ruleForm.enabled" :label="true" :disabled="isLook">禁用</el-radio>
                                </el-form-item>
                                <el-form-item label="备注:" prop="remark">
                                    <el-input type="textarea" placeholder="长度不超过30个字符" :maxlength="30" :rows="5" v-model="ruleForm.remark" :disabled="isLook"  @input="getSizeNum"></el-input>
                                  <span class="textarea_tip" v-show="!isLook">{{currentNum1}}/30</span>
                                </el-form-item>
                            </el-form>
                        </div>
                        <div class="mains_right" :style="{width:basicWidth+'px',height:basicHeight+'px'}">
                          <div class="roles_tree">
                            <el-tree
                              :data="data"
                              show-checkbox
                              @node-expand="expandScroll"
                              @node-collapse="collapseScroll"
                              node-key="id"
                              @check="selectTreeId"
                              :default-expanded-keys="selectTree"
                              :default-checked-keys="selectTree"
                              :props="defaultProps">
                            </el-tree>
                          </div>
                        </div>
                    </div>
                </el-row>
            </el-main>
        </el-container>
    </div>
</template>
<script>
    import topNav from '../../components/TopNav.vue';
    import {ajaxFuncJson} from '@/api/ajax';
    export default {
        name: 'editorialRole',
        components: {
            topNav,
        },
        data() {
            return {
                msg: '新增角色',
                tableW: '',
                tableW1: '',
                editRoles: {
                    names: '',
                    remark: '',
                    enabled: '',
                    id: '', //角色id
                },
                ruleForm: { //表单提交数据
                    name: '', //角色名
                    remark: '', //备注
                    enabled: false, //状态 1 启用  0 停用
                    menuIds: [], //资源菜单集合
                    roleType:3,
                },
              data: [],
              defaultProps: {
                children: 'list',
                label: 'menuName'
              },
              id:'',
              basicWidth:0,
              basicHeight:0,
              selectTree:[],
              baseName:'',
              baseRemark:'',
              baseEnabled:'',
              isManger:false,
              isLook:false,
              isTreeChange:false,
              currentNum1:0,
              windowResize:null,
              newArr:[],
              basicTree:[],
            }
        },
        created(){
          if(this.$route.query.type==='add'){
            this.msg='新增角色';
            this.getRightTreeInfo();
          }else {
            if(this.$route.query.type==='look'){
              this.msg='查看';
              this.isLook=true;
              this.defaultProps.disabled='enabled';
            }else {
              this.msg='编辑角色';
            }
            this.id=this.$route.query.id;
            this.getFindRoles();
            if(this.$route.query.roleType=='2'){
                this.isManger=true;
            }
          }
        },
        computed:{
            getMap() {
                return this.$store.state.buildingId
            },
        },
        watch: {
            getMap (newV, oldV) { // status的变化，然后执行操作
                
            },
        },
        mounted() {
            let that = this;
            that.windowResize= function () {
                that.tableW = ($('.el-row').width() - $('.mains_left').outerWidth(true) -1) * 0.25;
                that.tableW1 = ($('.el-row').width() - $('.mains_left').outerWidth(true) -1) * 0.5;
                that.basicWidth=$('body').width()-40-$('.mains_left').outerWidth(true);
                that.basicHeight=$('body').height()-68-61-10;
                that.isScroll();
            };
          that.windowResize();
          window.addEventListener('resize',that.windowResize);
        },
        methods: {
          isScroll(){
            this.$nextTick(()=>{
              let sHeight=document.getElementsByClassName('mains_right')[0].scrollHeight,
                cHeight=document.getElementsByClassName('mains_right')[0].clientHeight;
              if(sHeight>cHeight){
                document.getElementsByClassName('mains')[0].style.marginRight='3px';
                this.basicWidth=$('body').width()-23-$('.mains_left').outerWidth(true);
              }else {
                this.basicWidth=$('body').width()-40-$('.mains_left').outerWidth(true);
                document.getElementsByClassName('mains')[0].style.marginRight='20px';
              }
            });
          },
          expandScroll(){
            let _this=this;
            setTimeout(function () {
              _this.isScroll();
            },200);
          },
          collapseScroll(){
            let _this=this;
            setTimeout(function () {
              _this.isScroll();
            },200);
          },
          getSizeNum(val){
            this.currentNum1=val.length;
          },
            selectTreeId(row,rows){
              this.ruleForm.menuIds=rows.checkedKeys.concat(rows.halfCheckedKeys);
            },
            // 获取角色信息 - 左侧
            getFindRoles() {
                let parms = {
                    roleId: this.id, //角色id
                };
                ajaxFuncJson('/roles/findRoles',parms).then(res=>{
                    if(res.data.status == 200){
                        this.ruleForm.name=res.data.data.role.name;
                        this.baseName=res.data.data.role.name;
                        this.baseRemark=res.data.data.role.remark;
                        this.baseEnabled=res.data.data.role.enabled;
                        this.ruleForm.remark=res.data.data.role.remark;
                        if(this.ruleForm.remark){
                          this.currentNum1=this.ruleForm.remark.length;
                        }
                        this.ruleForm.enabled=res.data.data.role.enabled;
                        this.ruleForm.menuIds=res.data.data.role.menuIdList;
                        this.selectTree=res.data.data.role.menuIdList;
                        this.basicTree=JSON.parse(JSON.stringify(res.data.data.role.menuIdList));
                      this.getRightTreeInfo();
                    }else {
                      this.$message({
                        message:res.data.msg,
                        type:'error'
                      })
                    }
                });
            },
          //更新数据时的树形显示 （去掉半选状态id避免视图半选状态id下全选）
         checked(id,data,newArr){
          data.forEach((item,index) => {
            if(item.id == id){
                if( !item.list||item.list.length == 0 ){
                  newArr.push(item.id)
                }
            }else{
              if(item.list){
                if( item.list.length !=0 ){
                  this.checked(id,item.list,newArr)
                }
              }
            }
          });
        },
            //获取右侧树形列表信息
            getRightTreeInfo(){
              ajaxFuncJson('/menu/getAllMenu','').then(res=>{
                  if(res.data.status==200){
                    this.data=res.data.data;
                    var newArr=[];
                    if(this.selectTree.length>0){
                      this.selectTree.forEach((a,b)=>{
                        this.checked(String(a),this.data,newArr)
                      })
                    }
                    this.selectTree = newArr;
                    this.isScroll();
                  }else {
                    this.$message({
                      message:res.data.msg,
                      type:'error'
                    })
                  }
              });
            },
            // 编辑角色信息
            getEditRoles() {
                this.ruleForm.id=this.id;
                ajaxFuncJson('/roles/editRoles',this.ruleForm).then(res=>{
                    if(res.data.status == 200){
                      this.$router.push({path:'/roleSaveSuccess',query:{id:this.id}})
                    }else {
                      this.$message({
                        message:res.data.msg,
                        type:'error'
                      })
                    }
                });
            },
            // 新增角色 - 保存按钮
            getAddRoles() {
              if(this.ruleForm.name==''){
                this.$alert('信息填写不完善，请完善信息！', '提示', {
                  confirmButtonText: '我知道了',
                  callback: action => {

                  }
                });
              }else {
                if(this.$route.query.type==='add'){
                  ajaxFuncJson('/roles/addRoles',this.ruleForm).then(res=>{
                    if(res.data.status == 200){
                      this.$router.push({path:'/roleSaveSuccess',query:{id:res.data.data}})
                    }else {
                      this.$message({
                        message:res.data.msg,
                        type:'error'
                      })
                    }
                  });
                }else {
                  this.getEditRoles();
                }
              }
            },
            linkIndex(){
              this.returnTip();
            },
            //返回按钮
            returnBtn(){
             this.returnTip();
            },
            valiteTree(){
              if(this.ruleForm.menuIds.length!==this.basicTree.length){
                this.isTreeChange=true;
              }else {
                this.isTreeChange=false;
                // if(this.selectTree.length===0){
                //   this.isTreeChange=false;
                // }else {
                //   let ary=[];
                //   this.selectTree.forEach((a,b)=>{
                //     if(a!==this.ruleForm.menuIds[b]){
                //       ary.push(b);
                //     }
                //   });
                //   if(ary.length>0){
                //     this.isTreeChange=true;
                //   }else {
                //     this.isTreeChange=false;
                //   }
                // }
              }
            },
            returnTip(){
              if(this.$route.query.type==='add'){
                if(this.ruleForm.name!=''||this.ruleForm.remark!=''||this.ruleForm.menuIds.length>0){
                  this.$confirm('本次新增内容尚未保存，确定退出吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    closeOnClickModal:false,
                    closeOnPressEscape:false,
                  }).then(() => {
                    this.$router.push({path:'/roleManger'})
                  }).catch(() => {

                  });
                }else {
                  this.$router.push({path:'/roleManger'})
                }
              }else {
                this.valiteTree();
                if(this.ruleForm.name!=this.baseName||this.ruleForm.remark!=this.baseRemark||this.ruleForm.enabled!=this.baseEnabled||this.isTreeChange){
                  this.$confirm('本次编辑内容尚未保存，确定退出吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    closeOnClickModal:false,
                    closeOnPressEscape:false,
                  }).then(() => {
                    this.$router.push({path:'/roleManger'})
                  }).catch(() => {

                  });
                }else {
                  this.$router.push({path:'/roleManger'})
                }
              }
            },
        },
        destroyed(){
          let _this=this;
          window.removeEventListener("resize",_this.windowResize)
        },
    }
</script>
<style lang="scss" scope>
    @import "@/assets/css/mixin.scss";
    #editorialRole {
        height: 100%;
        .el-container {
            .el-main {
                width: 100% !important;
                margin: 0 !important;
                background: #f2f2f2;
                .el-row {

                }
              .mainHead{
                .el-button + .el-button{
                  margin-left: 6px;
                }
                margin: 10px 20px 0 20px;
              }
            }
        }
    .mains{
      background: #ffffff;
      margin-right: 20px;
      margin-left: 20px;
    }
    .mains_left {
        float: left;
        margin: 20px 40px 0 0;
        .demo-ruleForm.el-form .el-form-item{
          margin-bottom: 20px!important;
          .el-radio{
            margin-right: 100px;
          }
        }
      .is_look{
        .el-form-item{
          .el-input__inner{
            cursor: text;
          }
        }
      }
        .el-form{
          margin-top: 0;
        }
        .el-textarea__inner{
          height: 120px;
        }
        .textarea_tip{
          position: absolute;
          right: 15px;
          bottom: 3px;
          color: #8a8a8a;
          font-size: 12px;
          z-index: 1;
          padding: 0 2px;
          background: #fff;
          line-height: 1;
        }
      }
      .mains_right {
        float: left;
        overflow: auto;
        .roles_tree{
          margin-top: 20px;
        }
        .el-table--small th, .el-table--small td {
          text-align: left;
        }
        .el-table--border th:first-child .cell, .el-table--border td:first-child .cell {
          padding-left: 20px;
        }
      }
      .router_link{
        cursor: pointer;
      }
      .router_link:hover{
        color:#198CFF;
        cursor: pointer;
      }
    }
</style>



// WEBPACK FOOTER //
// src/page/systemManger/editorialRole.vue